






import { Component, Prop, Vue } from 'vue-property-decorator';
import { ExprCall } from '../../cablin/exprs';
import CommandCallComp from '../command/CommandCall.vue';

@Component({
  components: {
    CommandCallComp,
  },
})
export default class ExprCallComp extends Vue {
  @Prop() private expr!: ExprCall
}
